import { Component, inject, input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { NewsItemFacade } from '@app/store/news-item';

@Component({
    selector: 'app-delete-button',
    templateUrl: './delete-button.component.html',
    styleUrls: ['./delete-button.component.css'],
    imports: [TranslateModule, ButtonModule],
})
export class DeleteButtonComponent {
    private readonly newsItemFacade = inject(NewsItemFacade);
    private readonly confirmationService = inject(ConfirmationService);
    private readonly translateService = inject(TranslateService);

    readonly newsItemId = input.required<string>();
    readonly saving = input<boolean>(false);
    readonly testId = input.required<string>();

    onDelete(): void {
        this.confirmationService.confirm({
            header: this.translateService.instant('news.delete.header'),
            message: this.translateService.instant('news.delete.message'),
            icon: 'pi pi-exclamation-triangle',
            rejectButtonProps: {
                label: this.translateService.instant('news.delete.reject'),
                severity: 'secondary',
                outlined: true,
            },
            acceptButtonProps: {
                label: this.translateService.instant('news.delete.accept'),
                severity: 'danger',
            },
            accept: () => {
                this.newsItemFacade.deleteNewsItem(this.newsItemId());
            },
        });
    }
}
